import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController, ToastController, Platform } from 'ionic-angular';
import { Validators, FormBuilder, FormGroup } from '@angular/forms';
import { CustomerLicensePlateExistsValidator } from '../../validators/customer-license-plate-exists';
import { CustomersService } from '../../services/customers/customers-service';
import { Customer } from '../../models/customer';

@IonicPage()
@Component({
  selector: 'page-customer-vehicle',
  templateUrl: 'customer-vehicle.html',
})
export class CustomerVehiclePage {
  public Customer: Customer;
  private vehicleForm: FormGroup;
  public vehicleYears: Array<number>;
  public isCordova: boolean;
  public selectOptions: any = { cssClass: null };

  // Event handler for when the view has
  // completed loading.
  ionViewDidLoad() {

    // set available vehicle years.
    // available vehicle years.
    this.setVehicleYears();

    // Define custom select classes if
    // not in mobile env.
    this.selectOptions.cssClass = this.isCordova ? null : 'extra-wide';
  }

  private setVehicleYears() {
    this.vehicleYears = [];
    let maxYear = (new Date()).getFullYear() + 2;
    for(let i = maxYear; i > maxYear-100; i--)
    {
      this.vehicleYears.push(i);
    }
  }

  // Alert error notification.
  getError(ctrl) {
    return typeof ctrl === 'object' && ctrl.hasOwnProperty("errors") ? (ctrl.errors ? Object.keys(ctrl.errors)[0] : false) : false;
  }

  // Key-press event handler sanitizes
  // input values for license plate numbers.
  licensePlateMask(keyCode) {
    return (/[a-zA-Z0-9]/.test(String.fromCharCode(keyCode)));
  }

  toCamelCase(str): string {
    return str.split("_").map(function(word,index){

      // If it is the first word make sure to lowercase all the chars.
      if(index == 0) {
        return String(word).toLowerCase();
      }

      // If it is not the first word only upper case the first char and lowercase the rest.
      return String(word).charAt(0).toUpperCase() + String(word).slice(1).toLowerCase();

    }).join("");
  }

  save(vehicleForm)
  {
    let self: CustomerVehiclePage = this;
    let p: string;

    for(p in vehicleForm)
    {
      if(vehicleForm[p] === this.Customer.get(p))
      {
        delete vehicleForm[p];
      }
    }

    if(Object.keys(vehicleForm).length === 0)
    {
      let toast = this.toastCtrl.create({
        message: `There were no changes to ${self.Customer.name()}'s account to save.`,
        duration: 6000,
        position: "top"
      });
      toast.present();
      return;
    }

    let loading = this.loadingCtrl.create({
      content: "Saving..."
    });

    loading.present();

    this.custService.update(this.Customer.get("meta").subscription_id,{vehicle: vehicleForm})
      .subscribe(
        res => {
          loading.dismiss();

          // change to camelCase
          let o: object = {};
          for(var e in res){ o[self.toCamelCase(e)] = res[e]; }

          // store customer record.
          self.Customer = new Customer(o);
          self.custService.set(self.Customer);

          // toast!
          let toast = this.toastCtrl.create({
            message: `Success. ${self.Customer.name()}'s account was successfully updated.`,
            duration: 6000,
            position: "top"
          });

          toast.present();
        },
        rej => {
          loading.dismiss();

          let toast = this.toastCtrl.create({
            message: rej.error.message,
            duration: 8000,
            position: "top"
          });

          toast.present();
        }
      );
  }

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public custService: CustomersService,
    private toastCtrl: ToastController,
    private loadingCtrl: LoadingController,
    private platform: Platform,
    private formBuilder: FormBuilder,
    private licensePlateExistsValidator: CustomerLicensePlateExistsValidator) {

      // Identify if this is browser or device.
      this.isCordova = this.platform.is('cordova');

      // set customer data model.
      this.Customer = this.custService.get();

      // create form controls group
      this.vehicleForm = this.formBuilder.group({
        vehicleMake: [this.Customer.get("vehicleMake"), Validators.compose([Validators.required])],
        vehicleModel: [this.Customer.get("vehicleModel"), Validators.compose([Validators.required])],
        vehicleYear: [this.Customer.get("vehicleYear"), Validators.compose([Validators.required])],
        licensePlate: [this.Customer.get("licensePlate"), 
          Validators.compose([Validators.required]), 
          this.licensePlateExistsValidator.excludeId(this.Customer.get("meta").contact_id).checkLicensePlate.bind(this.licensePlateExistsValidator)
        ]
      });
  }
}


// WEBPACK FOOTER //
// ./src/pages/customer-vehicle/customer-vehicle.ts